import { Bank } from "../../models/bank/bank.model";
import { OcmsFund } from "../../models/bank/selectedFund/selectedFund.model";

export const mockBank: Bank = {
  SatisfiesRequirementsDisclaimer: true,
  Customer: {
    Language: "it",
    Salutation: "003",
    Email: "spac@corner.ch",
    FirstName: "test firstname",
    LastName: "test lastname",
    Phones: [
      {
        LocalNumber: "7911111111",
        Type: "Mobile",
        Number: "+417911111111",
        CountryCode: "+41",
      },
    ],

    DateOfBirth: "19800101",
    MaritalStatus: "02",
    Nationality: "IT",
    PlaceOfBirth: "FR",
    SocialSecurityNumber: "333.4444.4444.22",
    LPP: true,

    FinancialInformation: {
      Occupation: "Employed", // Employed, Freelancer
      Qualification: "test professione",
    },

    Addresses: [
      {
        Street: "Test street",
        StreetNumber: "test street number",
        ZipCode: "6900",
        City: "Lugano",
        Country: "CH",
        Type: "Home",
      },
    ],
  },
};
